export default "__VITE_ASSET__jUPsGUMz__"